/**
 * MyyVC Website Route Configuration
 * 
 * Clean, professional multi-page structure:
 * - Home: Hero landing and intro content
 * - About: Company info + Investment focus 
 * - Partnerships: University partnerships and collaborations
 * - Challenges: Innovation challenges + events
 */
const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/about", 
    component: "About",
    exact: true,
  },
  {
    path: "/partnerships",
    component: "Partnerships", 
    exact: true,
  },
  {
    path: "/challenges",
    component: "Challenges",
    exact: true,
  },
  {
    path: "/careers",
    component: "Careers",
    exact: true,
  },
];

export default routes;
